import React, { Component } from 'react';
import styles from './styles.scss';
import Routes from 'router/routes';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ModalOutlet from 'components/modals/modalOutlet';
import Spinner from 'components/loader';
import Drawer from 'components/util/drawer';
import Snackbar from 'components/util/snackBar';
import { Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { getConfig } from 'actions/api/config';
import { setSessionSettings } from 'actions/sessionSettings';
import { setAuthToken } from 'actions/util/setAuthToken';
import { userActions } from 'actions/api/users';
import jwt from 'jsonwebtoken';
import { history } from 'index';
import { languageActions } from 'actions/api/languages';
import Overlay from 'components/util/overlay';

import 'assets/css/bootstrap-grid.min.css';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#1899d8',
    accent1Color: '#1899d8',
    disabledColor: '#777777',
    fontWeight: 100
  },
  datePicker: {
    color: '#1899d8',
    selectColor: '#1899d8',
    calendarYearBackgroundColor: '#1899d8',
    headerColor: '#1899d8'
  }
});

class App extends Component {
  state = {
    initialized: false
  };

  componentWillMount() {
    this.initialize();
  }

  initialize = async () => {
    await Promise.all([
      this.props.getConfig({}),
      this.authenticateUser(),
      this.props.languageSearch({})
    ]);
    this.setState({ initialized: true });
  };

  authenticateUser = () => {
    return new Promise(async resolve => {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
        const currentUser = jwt.decode(localStorage.token);
        this.props.setSessionSettings({
          path: ['currentUserId'],
          data: currentUser.sub
        });

        await this.props.userSearch({ data: { id: currentUser.sub } });
        resolve();
      } else {
        resolve();
        history.push('/sign-in');
      }
    });
  };

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className={styles.fullHeight}>
          <Router history={history}>
            <div className={styles.fullHeight}>
              {this.state.initialized && (
                <div className={styles.fullHeight}>
                  <div id="content-wrapper" className={styles.fullHeight}>
                    <Routes />
                  </div>
                </div>
              )}
              <ModalOutlet />
              <Overlay />
              <Drawer />
              <Snackbar />
            </div>
          </Router>
          <Spinner />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default connect(
  state => {
    return {
      config: state.config,
      isAuthenticated: !!state.sessionSettings.currentUserId
    };
  },
  {
    getConfig,
    setSessionSettings,
    userSearch: userActions.search,
    languageSearch: languageActions.search
  }
)(App);



// WEBPACK FOOTER //
// ./src/components/app/index.js